var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ul',{staticClass:"container tabs"},_vm._l((_vm.tabs),function(tab,name){return _c('li',{key:name,class:tab.active ? 'active' : '',on:{"click":function($event){return _vm.changeTab(name)}}},[_vm._v(_vm._s(tab.label))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }